import { Portfolio } from "../../../graphql/generated";
import AboutSection from "./comps/AboutSection";
import BlogsSection from "./comps/BlogsSection";
import ContactSection from "./comps/ContactSection";
import HomeSection from "./comps/HomeSection";
import ProjectsSection from "./comps/ProjectsSection";
import ResumeSection from "./comps/ResumeSection";

export const homeSections: {
  index: number;
  component: React.FC<{ portfolioData: Omit<Portfolio, "createdBy"> }>;
}[] = [
  {
    index: 0,
    component: HomeSection,
  },
  {
    index: 1,
    component: AboutSection,
  },
  {
    index: 2,
    component: ResumeSection,
  },
  {
    index: 3,
    component: ProjectsSection,
  },
  {
    index: 4,
    component: BlogsSection,
  },
  {
    index: 5,
    component: ContactSection,
  },
];
